import React, { useEffect, useState } from "react";
import { Row, Col, Form, Select, Input, Modal, Typography, notification } from "antd";
import { ExclamationCircleOutlined, CheckOutlined, CloseOutlined } from "@ant-design/icons";
import moment from "moment";

import api from "../../../services/api";
import { Cedulas, InputPreco } from "../../../components";
import { useStateValue } from "../../../state";
import { carregarDadosPdv } from "../../../services/funcoes";
import { dadosPdvActions } from "../../../actions";
import { getParametrosEmpresa } from "../../../services/auth";

export default function ModalSuprimentoCaixa({ exibirModalSuprimentoCaixa, fecharModalSuprimentoCaixa }) {

    const [{ dadosPdv }, dispatch] = useStateValue();
    const [form] = Form.useForm();
    const [parametrosEmpresa, setParametrosEmpresa] = useState({});
    const [listaContaGerencial, setListaContaGerencial] = useState([]);
    const [keyCedulas, setKeyCedulas] = useState(Date.now());

    const onCloseModal = () => {
        Modal.confirm({
            title: 'Cancelar?',
            icon: <ExclamationCircleOutlined />,
            content: 'Deseja cancelar a operação?',
            okText: 'Sim',
            cancelText: 'Não',
            centered: true,
            onOk() {
                fecharModalSuprimentoCaixa();
                form.resetFields();
                setKeyCedulas(Date.now());
            }
        });
    };

    useEffect(() => {
        if (exibirModalSuprimentoCaixa) {
            let empresa = getParametrosEmpresa();
            setParametrosEmpresa(empresa);
            carregarDados();
            setKeyCedulas(Date.now());
        }
    }, [exibirModalSuprimentoCaixa])

    useEffect(() => {
        if (!!listaContaGerencial && listaContaGerencial.length > 0) {
            if (!!parametrosEmpresa.par_contagerencialsuprimentopdv) {
                form.setFieldsValue({ ctg_id: parametrosEmpresa.par_contagerencialsuprimentopdv });
            }
        }
    }, [listaContaGerencial])

    useEffect(() => {
        if (!!!dadosPdv.pdv) {
            verificaPdv();
        }
    }, [])

    async function verificaPdv() {
        let res = await carregarDadosPdv();
        dispatch({ type: dadosPdvActions.CHANGE, data: { pdv: res } });
    }

    async function carregarDados() {
        api.get(`ContaGerencial/ListarAtivos`).then(
            res => {
                setListaContaGerencial(res.data);
            }
        ).catch(
            error => {
                console.log(error);
            }
        )
    }

    function salvarLancamento() {
        let dados = form.getFieldsValue();
        let dadosCtg = listaContaGerencial.filter((item) => (item.ctg_id === dados.ctg_id))[0];
        dados.mcc_entradasaida = 2;
        dados.ctg = {
            ctg_descricao: dadosCtg.ctg_descricao,
            ctg_id: dadosCtg.ctg_id
        }
        dados.ctc_id = dadosPdv.pdv?.ctc_id;
        dados.mcc_valor = parseFloat(dados.mcc_valor);
        dados.mcc_complemento = !!dados.mcc_complemento ? dados.mcc_complemento : '';
        api.post(`MovimentoContaCorrente/IncluirLancamentoCaixa`, dados).then(
            res => {
                notification.success({ message: 'Sucesso!', description: 'Suprimento Incluido com Sucesso!' });
            }
        ).catch(
            error => {
                console.log(error);
                notification.warning({ message: 'Aviso!', description: 'Erro ao efetuar o suprimento do caixa!' });
            }
        ).finally(() => {
            form.resetFields();
            fecharModalSuprimentoCaixa();
        })
    }

    return (
        <Modal centered
            title="Suprimento do Caixa"
            open={exibirModalSuprimentoCaixa}
            getContainer={false}
            onCancel={onCloseModal}
            onOk={() => salvarLancamento()}
            okText={
                <>
                    <CheckOutlined /> Ok
                </>
            }
            cancelText={
                <>
                    <CloseOutlined /> Cancelar
                </>
            }
            maskClosable={false}
        >
            <div className="col-modal">
                <Form layout="vertical" name="manutencaoSuprimentoCaixa" form={form}>
                    <Row>
                        <Col span={24}>
                            <Typography.Text>
                                Informe os dados para o suprimento do caixa.
                            </Typography.Text>
                        </Col>
                    </Row>
                    <Row gutter={[8, 0]} className="m-t-8">
                        <Col span={8}>
                            <InputPreco label="Valor (R$)" name="mcc_valor" />
                        </Col>
                        <Col span={16}>
                            <Form.Item label="Conta Gerencial" name="ctg_id" rules={[{ required: true, message: 'Informe uma Conta Gerencial!' }]}>
                                <Select allowClear optionFilterProp="children" showSearch placeholder="Selecione uma Conta Gerencial">
                                    {listaContaGerencial.map((conta) => (
                                        <Select.Option value={conta.ctg_id} key={conta.ctg_id} label={conta.ctg_descricao}>{conta.ctg_descricao}</Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24}>
                            <Form.Item label="Observação" name="mcc_complemento">
                                <Input.TextArea placeholder="Informe uma Observação" />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Cedulas key={keyCedulas} formulario={form} />
                </Form>
            </div>
        </Modal>
    );
}